/**
 * Simple Google Analytics 4 Helper
 * Easy event tracking for your Coach Cedar site
 */

// Extend window type for gtag
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

/**
 * Track a custom event in Google Analytics
 * @param eventName - Name of the event (e.g., 'user_signup', 'chat_message')
 * @param parameters - Optional parameters to send with the event
 */
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    const pageTitle = typeof document !== 'undefined' ? document.title : 'Coach Cedar';
    const pageLocation = window.location ? window.location.href : 'N/A';
    window.gtag('event', eventName, {
      // Default parameters
      page_title: pageTitle,
      page_location: pageLocation,
      // Custom parameters
      ...parameters
    });
  }
};

/**
 * Track user authentication events
 */
export const trackAuth = (action: 'login' | 'logout' | 'signup', userId?: string) => {
  trackEvent(`user_${action}`, {
    user_id: userId,
    method: 'invite_token'
  });
};

/**
 * Track chat interactions
 */
export const trackChat = (action: 'message_sent' | 'response_received', metadata?: Record<string, any>) => {
  trackEvent(`chat_${action}`, {
    ...metadata
  });
};

/**
 * Track page views (if you want custom tracking beyond automatic)
 */
export const trackPageView = (pageName: string, additionalParams?: Record<string, any>) => {
  trackEvent('page_view', {
    page_name: pageName,
    ...additionalParams
  });
};

/**
 * Track user engagement
 */
export const trackEngagement = (action: string, value?: number) => {
  trackEvent('engagement', {
    engagement_action: action,
    value: value
  });
};

/**
 * Track business events
 */
export const trackBusiness = (event: 'subscription_start' | 'trial_start' | 'conversion', value?: number) => {
  trackEvent(event, {
    currency: 'USD',
    value: value
  });
}; 